var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{attrs:{"data-v-17902353":"","width":"14","height":"7","viewBox":"0 0 10 7","fill":"none","xmlns":"http://www.w3.org/2000/svg"}},[_c('path',{attrs:{"data-v-17902353":"","d":"M1 1.03467L5 5.03467L9 1.03467","stroke":"#000000","stroke-width":"3","stroke-linecap":"round","stroke-linejoin":"round"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }